import { Component, OnInit } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

export interface PeriodicElement {
  productName: string;  
  bidStartDate: string;
  bidEndDate: string;
  sku: string;
  action: string;
}
const ELEMENT_DATA: PeriodicElement[] = [
  {productName: 'Julie Fuller', bidStartDate: '01/05/2012', bidEndDate: '28/10/2012', sku: '123456', action: ''},
  {productName: 'Julie Fuller', bidStartDate: '01/05/2012', bidEndDate: '28/10/2012', sku: '123456' , action: ''},
  {productName: 'Julie Fuller', bidStartDate: '01/05/2012', bidEndDate: '28/10/2012', sku: '123456', action: ''},
  {productName: 'Julie Fuller', bidStartDate: '01/05/2012', bidEndDate: '28/10/2012', sku: '123456', action: ''},
  {productName: 'Julie Fuller', bidStartDate: '01/05/2012', bidEndDate: '28/10/2012', sku: '123456', action: ''},
];
@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ListingComponent implements OnInit {
  displayedColumns: string[] = ['productName', 'bidStartDate', 'bidEndDate', 'sku', 'action'
  // 'description'
];
  dataSource = ELEMENT_DATA;
  expandedElement: PeriodicElement | null;
  constructor() { }

  ngOnInit(): void {
  }

}
